import { render, staticRenderFns } from "./KpiGastos.vue?vue&type=template&id=64dc5794&scoped=true&"
import script from "./KpiGastos.vue?vue&type=script&lang=js&"
export * from "./KpiGastos.vue?vue&type=script&lang=js&"
import style0 from "./KpiGastos.vue?vue&type=style&index=0&id=64dc5794&prod&lang=scss&"
import style1 from "./KpiGastos.vue?vue&type=style&index=1&id=64dc5794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc5794",
  null
  
)

export default component.exports